import { useContext } from "react"
import HoverSyncContext from "helpers/contexts/HoverSyncContext"

export const useHoverSync = () => {
  const context = useContext(HoverSyncContext)
  if (!context) {
    throw new Error("useHoverSync must be used within HoverSyncProvider")
  }
  return context
}
